export default __webpack_public_path__ + "static/media/north-star-account.f1817071.png";